"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
exports.__esModule = true;
exports.default = void 0;
var _styledComponents = require("styled-components");
var _getSpacingToken = _interopRequireDefault(require("../../../common/getSpacingToken"));
var _getDisplay = _interopRequireDefault(require("./getDisplay"));
const getViewportGridStyles = ({
  viewport,
  theme
}) => props => {
  if (props[viewport]) {
    const {
      inline,
      maxWidth,
      gap,
      columnGap,
      rowGap,
      rows,
      columns,
      width,
      spaceAfter
    } = props[viewport];
    return (0, _styledComponents.css)(["", ";max-width:", ";width:", ";grid-template-columns:", ";grid-template-rows:", ";grid-column-gap:", ";grid-row-gap:", ";grid-gap:", ";margin-bottom:", ";"], (0, _getDisplay.default)(inline, viewport === "smallMobile"), maxWidth, width, columns, rows, columnGap, rowGap, gap, (0, _getSpacingToken.default)({
      spaceAfter,
      theme
    }));
  }
  return (0, _styledComponents.css)([""]);
};
var _default = getViewportGridStyles;
exports.default = _default;